/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Can I nest rules?"
    }), "\n", _jsx(_components.p, {
      children: "Yes: nesting is a feature intentionally ported from Sass. Used sparingly it's a\ngreat way to lighten your code by reducing the need to create explicit classes for every element."
    }), "\n", _jsx(_components.p, {
      children: "It can also be used by parent components to define contextual constraints that aren't properly a concern of the affected children:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const EqualDivider = styled.div`\n  display: flex;\n  margin: 0.5rem;\n  padding: 1rem;\n  background: papayawhip;\n  ${props => props.$vertical && \"flex-direction: column;\"}\n\n  > * {\n    flex: 1;\n\n    &:not(:first-child) {\n      ${props => props.$vertical ? \"margin-top\" : \"margin-left\"}: 1rem;\n    }\n  }\n`;\n\nconst Child = styled.div`\n  padding: 0.25rem 0.5rem;\n  background: #BF4F74;\n`;\n\nrender(\n  <div>\n  <EqualDivider>\n    <Child>First</Child>\n    <Child>Second</Child>\n    <Child>Third</Child>\n  </EqualDivider>\n  <EqualDivider $vertical>\n    <Child>First</Child>\n    <Child>Second</Child>\n    <Child>Third</Child>\n  </EqualDivider>\n  </div>\n);\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "It's also incredibly convenient to co-locate media queries, since we can see at a glance\nexactly how the component will respond at any resolution."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const ColorChanger = styled.section`\n  background: papayawhip;\n  color: #BF4F74;\n\n  @media(min-width: 768px) {\n    background: mediumseagreen;\n    color: papayawhip;\n  }\n`;\n\nrender(\n  <ColorChanger href=\"#\">\n    <h2>Hello world!</h2>\n  </ColorChanger>\n);\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
